import { StyledSwitchTheme, styles, variants } from '../StyledSwitchStyles.css';
import { multiVariantStyles } from './StyledSwitchVariants.css';

/*******************
 * Component Theme
 *******************/

const StyledSwitchStableTheme: StyledSwitchTheme = {
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { StyledSwitchStableTheme };
